module.exports = __webpack_public_path__ + "271d3c968af2c8708a4ca39ae4e8054b.MP3";